module.exports = __webpack_public_path__ + "static/project-7b-55e9f8648f1ebe2208c9900ab9aa6a72.png";